/**
 * Create Content Groups context for custom hook
 */
import { createContext } from 'react'

const ContentGroupsContext = createContext({
  // fetchContentGroupV1: () => {},
  fetchContentGroupByCode: () => {},
  fetchContentGroup: () => {}
})

export default ContentGroupsContext
